module.exports = __webpack_public_path__ + "static/media/music.265ce03b.svg";